document.addEventListener('theme:product:add', function(event) {
  addToCartIcomm(event);
});


function addToCartIcomm(event) {

  window._imMktOptions = {
    _setType: 'Lead',
    _setDomain: 'www.news.abbacino.es',
    _itemsQuantity: event.detail.response.quantity,
    _amount: (event.detail.response.final_line_price / 100).toFixed(2),
    _extraInfo: `product_id: ${event.detail.response.id}, variant_id: ${event.detail.response.variant_id}`
  };

  (function() {
    var icomMkt = document.createElement('script');
    icomMkt.type = 'text/javascript';
    icomMkt.async = true;
    icomMkt.src = (
      document.location.protocol === 'https:' 
        ? 'https://' 
        : 'http://'
    ) + 'externalassets.icommarketing.com/icomMkt_tracking_jquery.min.js';
    
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(icomMkt, s);
  })();
}